import apis from './apis';

export const fetchChatConfig = () => apis.get('chat/config');
